import { pickLookupLabel } from '@/utils/localizeLookupOptions';

/**
 * task_subtype 显示名按界面语言取（2026-09-26 review MEDIUM）。
 *
 * task_subtype 不是 lookup-table 字典（独立实体 pms.task_subtype），但带 `labelI18n`
 * （{en,zh,pt,es}，09-21 回填齐），规则与字典相同：非英文界面取译文，英文 / 缺译取规范 `label`
 * （见 pickLookupLabel）。两个数据源 useTaskCategoryData / useSubtypeLookup 在源头套用，
 * 下游所有 `.label` 显示点自动变成当前语言。
 *
 * 要**存进数据**的地方（按 subtype 拼的默认任务标题、打卡 work type 建单标题）用
 * `canonicalLabel`（规范英文 label）——不能让建单人的界面语言决定别人看到的标题。
 */
type SubtypeLike = { label: string; labelI18n?: Record<string, string> | null };

export function subtypeDisplayLabel(subtype: SubtypeLike, locale: string | undefined): string {
  return pickLookupLabel(subtype.labelI18n, locale, subtype.label);
}

export type Localized<T extends SubtypeLike> = T & { canonicalLabel: string };

/** 把 `label` 换成当前语言，原规范 label 留在 `canonicalLabel`。 */
export function localizeSubtype<T extends SubtypeLike>(subtype: T, locale: string | undefined): Localized<T> {
  return { ...subtype, label: subtypeDisplayLabel(subtype, locale), canonicalLabel: subtype.label };
}
